import { Injectable } from '@angular/core';
import { ConnectService } from '@epicuro-next/data/connect';
import {
  BroadcastService,
  EventType,
} from '@epicuro-next/platform/authentication';
import { MessageType, showSnackBarMessage } from '@epicuro-next/state/snackbar';
import { isNonNullish } from '@epicuro-next/utilities';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import {
  catchError,
  distinctUntilChanged,
  filter,
  map,
  switchMap,
} from 'rxjs/operators';

import * as fromConnectToken from './connect-token.actions';

@Injectable()
export class ConnectTokenEffects {
  constructor(
    private actions$: Actions,
    private store: Store,
    private connectService: ConnectService,
    private broadcastService: BroadcastService,
  ) {
    this.broadcastService.broadcast$
      .pipe(
        filter(
          (evt) =>
            typeof evt === 'object' &&
            evt.type === EventType.ACQUIRE_TOKEN_SUCCESS,
        ),
      )
      .subscribe(({ payload }) => {
        this.store.dispatch(
          fromConnectToken.acquireConnectToken({
            accessToken: (payload as { accessToken: string }).accessToken,
          }),
        );
      });
  }

  public acquireConnectToken$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromConnectToken.acquireConnectToken),
      filter(({ accessToken }) => isNonNullish(accessToken)),
      map(({ accessToken }) => accessToken),
      distinctUntilChanged(),
      switchMap(() =>
        this.connectService.acquireConnectToken().pipe(
          map((token) =>
            fromConnectToken.initConnectTokenStateSuccess({ token }),
          ),
          catchError((error) =>
            of(
              fromConnectToken.initConnectTokenStateFailure({
                error: error.message,
              }),
            ),
          ),
        ),
      ),
    ),
  );

  public resetConnectOnAcquireTokenInit$ = createEffect(() =>
    this.broadcastService.broadcast$.pipe(
      filter((evt) => {
        return (
          typeof evt === 'object' && evt.type === EventType.ACQUIRE_TOKEN_INIT
        );
      }),
      map(() => fromConnectToken.resetConnectToken()),
    ),
  );

  public initConnectStateFailure$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromConnectToken.initConnectTokenStateFailure),
      map(() =>
        showSnackBarMessage({
          message: $localize`:connect|Failed to init connect@@failedToInitConnect:Failed to initConnect`,
          hideDelay: 10000,
          messageType: MessageType.DANGER,
        }),
      ),
    ),
  );
}
